import { render } from "./tags.vue?vue&type=template&id=6f2a1f08&lang=pug"
import script from "./tags.vue?vue&type=script&setup=true&lang=js"
export * from "./tags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__